import {has, is, prop} from 'ramda';

import type {GetAuctionVehicleListApiResponse} from '../types';

export function isAuctionListResponse(data: unknown): data is GetAuctionVehicleListApiResponse {
  return is(Object, data) && has('data', data) && Array.isArray(prop('data', data));
}
